import { t } from 'i18next';
import { z } from 'zod';
import { InputRegexMap, OnboardingFormFields } from '@Types/index.ts';
import { ControlledTextInput } from './ControlledInputs';

const MAX_LINE1_CHARS = 40;

interface IProps {
  disabled: boolean;
  tabIndex: number;
}
export const Line1Input = ({ disabled, tabIndex }: IProps) => {
  return (
    <ControlledTextInput
      name={OnboardingFormFields.LINE1}
      title={t('pages.homeAddress.lineOneFieldTitle')}
      id={OnboardingFormFields.LINE1}
      disabled={disabled}
      tabindex={tabIndex}
      isPublic
    />
  );
};

export const Line1Schema = z.object({
  [OnboardingFormFields.LINE1]: z
    .string()
    .trim()
    .min(1, t('enErrors:required'))
    .min(2, t('enErrors:address.street.min'))
    .max(
      MAX_LINE1_CHARS,
      t('enErrors:address.street.max', {
        max: MAX_LINE1_CHARS,
      })
    )
    .regex(InputRegexMap.lineOneUS, t('enErrors:address.street.invalid')),
});
